module.exports = __webpack_public_path__ + "static/img/anxunSlogin.f66f9d23.png";